module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic7.e0353c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic7.png
// module id = 573
// module chunks = 1